/**
 * EnvironmentBanner Component
 *
 * Non-dismissable banner that displays the current environment (Sandbox/Production).
 * Fixed to the top of the viewport and remains visible during scrolling.
 */
import React from 'react';
import { Box, Typography } from '@mui/material';
import { Storage as SandboxIcon, Warning as ProductionIcon } from '@mui/icons-material';
import { useEnvironment } from '../../../hooks/useEnvironment';

export const EnvironmentBanner: React.FC = () => {
  const { environment } = useEnvironment();
  const isSandbox = environment === 'sandbox';

  return (
    <Box
      sx={{
        backgroundColor: isSandbox ? '#10b981' : '#ef4444',
        color: 'white',
        py: 0.5,
        px: 2,
        textAlign: 'center',
        fontSize: '0.875rem',
        fontWeight: 600
      }}
      role="banner"
      aria-live="polite"
      aria-label={`Current environment: ${environment}`}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
        {isSandbox ? (
          <SandboxIcon sx={{ fontSize: 16 }} />
        ) : (
          <ProductionIcon sx={{ fontSize: 16 }} />
        )}
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {isSandbox ? 'SANDBOX ENVIRONMENT' : 'PRODUCTION ENVIRONMENT'}
        </Typography>
      </Box>
    </Box>
  );
};

export default EnvironmentBanner;
